import { render } from "./select-delivery-method.vue?vue&type=template&id=6e8f5271"
import script from "./select-delivery-method.vue?vue&type=script&lang=js"
export * from "./select-delivery-method.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__